import React from 'react';

import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {MenuPanelSection} from 'ui-library/menus/MenuPanel';

import StepTypeSelector, {filterReplaceableSourceStepTypes} from '../components/add-step/StepTypeSelector';
import RightSidebarSkeleton, {RightSidebarWidth} from '../components/RightSidebarSkeleton';

const REPLACE_SOURCE_EXTRA_SECTIONS: Array<MenuPanelSection> = [
  {
    header: 'Combine existing tables',
    rows: [
      {
        id: PipelineStepType.JOIN,
        label: 'Join tables',
        description: 'Combine tables horizontally, merging rows.',
      },
      {
        id: PipelineStepType.UNION_DATASETS,
        label: 'Union tables',
        description: 'Combine tables vertically, merging columns.',
      },
    ],
  },
];

interface SelectStepTypePhaseProps {
  selectedStepType: PipelineStepType | null;
  setSelectedStepType: (stepType: PipelineStepType | null) => void;
  onCancel: () => void;
  onNext: () => void;
}

export default function SelectStepTypePhase({
  selectedStepType,
  setSelectedStepType,
  onCancel,
  onNext,
}: SelectStepTypePhaseProps): JSX.Element {
  return (
    <RightSidebarSkeleton
      title="Replace source"
      confirmationButtons={[
        {
          text: 'Cancel',
          onClick: onCancel,
          dataTestAttrsElement: 'cancel',
        },
        {
          text: 'Next',
          onClick: onNext,
          dataTestAttrsElement: 'next',
          disabled: !selectedStepType,
          isPrimary: true,
        },
      ]}
      width={RightSidebarWidth.WIDE}
      dataTestAttrs={{
        component: 'ReplaceSourceStepRightSidebar',
        element: 'root',
      }}
    >
      <StepTypeSelector
        selectedStepType={selectedStepType}
        onSelectStepType={setSelectedStepType}
        extraSections={REPLACE_SOURCE_EXTRA_SECTIONS}
        filterStepTypes={filterReplaceableSourceStepTypes}
      />
    </RightSidebarSkeleton>
  );
}
